<script>
import { Line, mixins } from "vue-chartjs";

export default {
  extends: Line,
  mixins: [mixins.reactiveProp],
  props: {
    label: {
      type: String,
      default: "BTC"
    }
  },
  data: function() {
    return {
      options: {
        // legendCallback: (chart) => {
        //   return '<p>Foo</p>';
        // },
        legend: {
          labels: {
            usePointStyle: true
            // filter: function(item, chart) {
            //   // this removes legends 3 and 4 (bittrex and binance)
            //   return true; // item.datasetIndex >= 2;
            // }
          }
        },
        tooltips: {
          callbacks: {
            label: item => {
              const label = this.chartData.datasets[item.datasetIndex].yAxisID;

              return `${item.yLabel.toFixed(label === "BTC" ? 5 : 2)} ${label}`;
            }
          }
        },
        scales: {
          xAxes: [
            {
              type: "time"
            }
          ],
          yAxes: [
            {
              id: "BTC",
              type: "linear",
              position: "left",
              scaleLabel: {
                display: true,
                labelString: "BTC"
              }
            },
            {
              id: "USD",
              type: "linear",
              position: "right",
              scaleLabel: {
                display: true,
                labelString: "USD"
              },
              gridLines: {
                display: false
              }
            }
          ]
        }
      }
    };
  },
  mounted() {
    this.renderChart(this.chartData, this.options);
  }
};
</script>



// WEBPACK FOOTER //
// resources/js/components/dashboard/AccountValueChart.vue